import React from "react";
import { Container, Paper } from "@mantine/core";

const AboutUsPage = () => {
  return (
    <Container size="md">
      <Paper padding="lg">
        <h1 style={{ textAlign: "center" }}>About Us</h1>
        <p>
          Welcome to Data4Research! We are a team of dedicated
          researchers and data scientists passionate about advancing knowledge
          and making a positive impact in the digital world. Our data-donation
          project aims to gather valuable insights into user behavior and online
          patterns to improve content creation, user experiences, and
          personalized recommendations.
        </p>

        <h3>Our Mission</h3>
        <p>
          Our mission is to conduct meaningful research that benefits users and
          content creators alike. By understanding how users engage with online
          content and the factors that influence their browsing habits, we aim
          to contribute to the development of a more enriching and user-centric
          online environment.
        </p>

        <h3>Our Approach</h3>
        <p>
          At Data4Research, we prioritize privacy and data security.
          We follow strict ethical guidelines and take comprehensive measures to
          ensure that all data collected from users is anonymized and kept
          confidential. We believe in transparency and open communication, and
          we are committed to being transparent about how user data is used and
          protected.
        </p>

        <h3>Why Donate Your Data?</h3>
        <p>
          You may wonder why we are asking for your YouTube watch history and
          Chrome browsing history data. The answer is simple: your data plays a
          crucial role in shaping the future of online experiences. By
          participating in our data-donation project, you contribute to the
          advancement of research that benefits all internet users. Your
          voluntary participation empowers us to make data-driven decisions that
          enhance content discovery, recommendation systems, and overall user
          satisfaction.
        </p>

        <h3>Get Involved</h3>
        <p>
          We encourage all users who are above the age of 18 to consider
          participating in our data-donation project. Your involvement is
          completely voluntary, and you have the right to withdraw your consent
          at any time. If you choose to donate your data, rest assured that it
          will be treated with the utmost care and responsibility. Together, we
          can make a positive impact on the digital landscape and create a
          better online experience for everyone.
        </p>

        <h3>Contact Information</h3>
        <p>
          If you have any questions or would like to learn more about our
          research or data-donation project, please feel free to contact us at
          [contact email/phone number]. We welcome your feedback, suggestions,
          and inquiries and look forward to engaging with our community of users
          and researchers.
        </p>
      </Paper>
    </Container>
  );
};

export default AboutUsPage;
